import { NewStackRoutes, PublicRoutes } from 'core/util/Route';

export const isNewStackRoute = (path: string): boolean => {
    return NewStackRoutes.some((route) => {
        return route.test(path);
    });
};

export const isPublicRoute = (path: string): boolean => {
    return PublicRoutes.some((route) => {
        return route.test(path);
    });
};

export const route = (path: string): string => {
    if (isNewStackRoute(path)) {
        return path;
    }

    return `${process.env.REACT_APP_OLD_STACK_HOST}${path}`;
};

export enum QueryStringParameter {
    Format = 'f', // e.g. PDF/HTML vs CSV
}

export const extractQueryStringParameters = (path: string): { [key: string]: string } =>
    path
        .replace(/^\?/, '')
        .split('&')
        .reduce((result: { [key: string]: string }, v) => {
            const parts = v.split('=');

            // eslint-disable-next-line no-param-reassign
            result[parts[0]] = decodeURIComponent(parts[1] || '');

            return result;
        }, {});
